import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { Dropdown, DropdownButton, DropdownContent, DropdownItem } from "@aviary";
import { PractitionerIAContext } from "@shared/context";
import { useCatalogSearch } from "@shared/hooks/useCatalogSearch";

import * as styles from "./CatalogSortDropdown.styles";

const SORT_TEXT_MAP = {
  RELEVANCE: {
    DESC: "BestMatch",
  },
  ALPHABETICAL: {
    ASC: "AlphabeticalAZ",
    DESC: "AlphabeticalZA",
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  MOST_PRESCRIBED: {
    DESC: "MostPrescribed",
  },
  PRICE: {
    ASC: "LeastExpensive",
    DESC: "MostExpensive",
  },
};

interface Props {
  isDisabled: boolean;
}

const CatalogSortDropdown = ({ isDisabled }: Props) => {
  const { t } = useTranslation();
  const { sortDirection, sortField, setSort, searchQuery } = useCatalogSearch();
  const { gaiaIaExperimentGroup } = useContext(PractitionerIAContext);
  const isIAExperiment = gaiaIaExperimentGroup === "ia_release_1";

  const prescribedTerm = isIAExperiment ? "MostRecommended" : SORT_TEXT_MAP.MOST_PRESCRIBED.DESC;

  const getCurrentSort = () => {
    if ((!sortField && !sortDirection && !searchQuery) || sortField === "MOST_PRESCRIBED") {
      return t("catalog:resultSort." + prescribedTerm);
    } else if (searchQuery && !sortField) {
      return t("catalog:resultSort." + SORT_TEXT_MAP.RELEVANCE.DESC);
    } else {
      return t("catalog:resultSort." + SORT_TEXT_MAP[sortField][sortDirection]);
    }
  };

  return (
    <Dropdown prefixText={t("common:Sort")} disabled={isDisabled}>
      <DropdownButton disabled={isDisabled} css={styles.dropdownBtn}>
        {getCurrentSort()}
      </DropdownButton>
      <DropdownContent css={styles.dropdownContent}>
        {searchQuery && (
          <DropdownItem onSelect={() => setSort(undefined, undefined)}>
            {t("catalog:resultSort." + SORT_TEXT_MAP.RELEVANCE.DESC)}
          </DropdownItem>
        )}
        <DropdownItem onSelect={() => setSort("MOST_PRESCRIBED", "DESC")}>
          {t(`catalog:resultSort.${prescribedTerm}`)}
        </DropdownItem>
        <DropdownItem onSelect={() => setSort("ALPHABETICAL", "ASC")}>
          {t("catalog:resultSort." + SORT_TEXT_MAP.ALPHABETICAL.ASC)}
        </DropdownItem>
        <DropdownItem onSelect={() => setSort("ALPHABETICAL", "DESC")}>
          {t("catalog:resultSort." + SORT_TEXT_MAP.ALPHABETICAL.DESC)}
        </DropdownItem>
        <DropdownItem onSelect={() => setSort("PRICE", "ASC")}>
          {t("catalog:resultSort." + SORT_TEXT_MAP.PRICE.ASC)}
        </DropdownItem>
        <DropdownItem onSelect={() => setSort("PRICE", "DESC")}>
          {t("catalog:resultSort." + SORT_TEXT_MAP.PRICE.DESC)}
        </DropdownItem>
      </DropdownContent>
    </Dropdown>
  );
};
export { CatalogSortDropdown };
